const BmHomePage = {
  path: '/index',
  name: 'bameiNewHomePage',
  meta: {
    noCheckLogin: true
  },
  component: () => import('@/pages/bameiNew/homePage')
};
const introduce = {
  path: '/introduce',
  name: 'bameiNewIntroduce',
  meta: {
    noCheckLogin: true
  },
  component: () => import('@/pages/bameiNew/introduce')
}; 
const bameiNewRouter = [
  BmHomePage,
  introduce,
];
  
export default bameiNewRouter;


// WEBPACK FOOTER //
// ./src/router/bameiNew.js